import React, { useEffect } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { bindActionCreators } from "redux";
import customerActions from "../../../Actions/customerActions";
import { connect } from "react-redux";
import MigrationList from "../MigrationList";

function Migrations({ customer, customerActions, dataLoading, migrations }) {
    const { t } = useTranslation();

    const customerNumber = customer.vbCustomer?.customerNumber ?? customer.vossCustomer?.customerNumber;
    const customerId = customer.vossCustomer?.id;

    useEffect(() => {
        if (!migrations && customerNumber) {
            customerActions.getCustomerMigrations(customerNumber, customerId);
        }
    }, []);

    if (dataLoading) {
        return <div className="spinner spinner-default-green m-auto d-block" />
    }

    if (!migrations || migrations.length === 0) {
        return <div className="col-xs-12 text-center p-24">
            <p>{t('migrations.noMigrations')}</p>
        </div>
    }

    return <MigrationList migrations={migrations} />
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        migrations: state.CustomerReducer.migrations,
        dataLoading: state.CommonReducer.dataLoading.migrations
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Migrations));
